import React,{useState,useEffect} from 'react';
import { Container,Row,Col } from 'react-bootstrap';
import './styles/App.css';
import M_Footer from './M_Footer';
import {Link} from 'react-router-dom';
import TopTitle from './Pc_TopTitle';
import queryString from 'query-string';
import axios from 'axios';
import check from './img/gg_check-o.png'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {CustomAlert,CustomAlert2,CustomAlert3, CustomAlert_x,instance,comma,currentDate} from './common';


function inputsCheck(inputs){
    let isCheck = false;
    let check = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
    if(check.test(inputs)){
        isCheck = true;
    }

    if(inputs.length != 13){
        isCheck = true;
    }
    console.log('isCheck : ', isCheck);
    return isCheck;
}
function checkNum(inputs,popup,setPopup){
    let isCheck = inputsCheck(inputs)
    if(!isCheck){
        const session = JSON.parse(window.sessionStorage.result);
        const {u_type} = session;
        
        let obj = {co_number:inputs,u_type:u_type}
        console.log('obj : ',obj)
        const fetchData = async () => {
            instance.post('/contract/number',obj).then(function(res){
                
                if(res.data.msg == 'nodata'){
                    setPopup({
                        ...popup,
                        no:true,
                    });
                }else if(res.data.msg == 'exist'){
                    setPopup({
                        ...popup,
                        ex:true,
                    });
                }else{
                    let {co_pro,co_discount} = res.data.rows[0];
                    updateNum(inputs,co_pro,co_discount,popup,setPopup);
                }
            });
            
        };
    
        fetchData();
    }else{
        setPopup({
            ...popup,
            format:true,
        });
    }
   
    
}


function updateNum(inputs,co_pro,co_discount,popup,setPopup){
    const session = JSON.parse(window.sessionStorage.result);
    const {u_login_id,u_type} = session;
    let obj;
    if(u_type == '일반고객'){
        obj = {co_user_id:u_login_id}
    }else if(u_type == '카마스터'){
        obj = {co_user_id2:u_login_id,is_use:1}
    }else if(u_type == '시공지점'){
        obj = {co_user_id2:u_login_id,is_use:1}
    }


    let valueObj = {
        obj:obj,
        whereField:'co_number',
        whereValue:inputs
    }
    
    const fetchData = async () => {
        instance.post('/contract/update',valueObj).then(function(res){
            if(u_type == '일반고객'){
                alert('현재권한은 일반고객입니다. 일반고객 관련 서비스 업데이트 준비중입니다.');
            }else if(u_type == '카마스터' || u_type == '시공지점'){
                if(co_pro == 1){
                    //alert('프로모션 대상 고객 계약번호 입니다.\n결제 단계를 건너뜁니다.');
                    setPopup({
                        ...popup,
                        ok:true,
                        pro:1,
                        co_discount:co_discount
                    });
                    
                }else if(co_pro == 0){
                    setPopup({
                        ...popup,
                        ok:true,
                        pro:0
                    });
                }
                //alert('정상적으로 차량추가가 되었습니다.\n차량정보에서 확인 해보세요.');
            }
            
        });
        
    };

    fetchData();
    
}


function RepInsert({history, location, match,r_id,date,si_id}) {


    const [inputs, setInputs]  = useState('');


    const [popup, setPopup] = useState({
        ok:false,
        no:false,
        ex:false,
        format:false,
        pro:0,
        co_discount:''
    });

    const {ok,no,ex,pro,format,co_discount} = popup;
    const goBack = () => {
        history.goBack();
    };




    const onClick = () => {
        checkNum(inputs,popup,setPopup);
        
    }

    const onChange = (e) => {

        const {name,value} = e.target;

        setInputs(value);
        
    }
        
        

    let isTitle = "계약번호 입력"

  return (
    
    <>
    {
        ok && <CustomAlert history={history} pro={pro} inputs={inputs} co_discount={co_discount}/>
    }
    {
        no && <CustomAlert2 setPopup={setPopup} popup={popup}/>
    }
    {
        ex && <CustomAlert3 setPopup={setPopup} popup={popup}/>
    }
    {
        ex && <CustomAlert3 setPopup={setPopup} popup={popup}/>
    }
    {
        format && <CustomAlert_x setPopup={setPopup} popup={popup}/>
    }
    
    <Container>
        <div className="text-center w-100 pcModalTitleText">계약번호 입력</div>
        <div className="c_pad">
            <h5 className="font-weight-bold mb-3">계약번호를 입력해주세요.</h5>
            <div className="c_flex">
                <div className="col">
                    <input name="num1" type="text" className="c_border" value={inputs} onChange={onChange} autoComplete="off" />
                </div>
            </div>
            <div className="c_flex">
                <div className="c_certify my-3">계약번호를 - 없이 입력해주세요</div>
            </div>
            <div className="btn btn-primary mt-3 r_btnsize" onClick={onClick}>등록</div>
        </div>
        
    </Container>
    </>
    
  );
}



function ModalPage({r_id,date,si_id,modal, toggle, Comp}){
    
    
    const mheight = {
        minHeight: '60vh'
    }

    return (
 

        <Modal isOpen={modal} toggle={toggle}>

        
            <ModalHeader toggle={toggle} className="text-center Pc_modalHeader" id="writeTitle">

            </ModalHeader>
        
            <ModalBody className="" style={mheight}>
                <RepInsert r_id={r_id} date={date} si_id={si_id}  />
            </ModalBody>
 
       </Modal>


        
    )
}

function LoadSigong({si_id}){
    const [data, setData] = useState([]);
    let obj = {si_id:si_id}

    useEffect(() => {
        
        const fetchData = async () => {
            instance.post('/sigong/id',obj).then(function(res){
                
                setData(res.data[0]);
            });
        
        };

        fetchData();

    }, []);

    const borderBottom = {
        borderBottom:'1px solid #ddd',
        marginTop:'50px'
    }

    console.log('확인 데이터 : ', data)
    return (
        <table className="table" style={borderBottom}>
            <thead>
            </thead>
            <tbody>
                <tr>
                    <td className="font-weight-bold tdPC text-left text-lightgray pt-3 pb-3">시공점</td>
                    <td className="font-weight-bold tdPC text-right pt-3 pb-3">{data.si_area1+ ' ' +data.si_area2+' '+data.si_name}</td>
                </tr>
                <tr>
                    <td className="font-weight-bold tdPC  text-lightgray pt-3 pb-3">예약정보</td>
                    <td className="font-weight-bold tdPC text-right pt-3 pb-3">{currentDate()}</td>
                </tr>
            </tbody>
            <tfoot></tfoot>
        </table>
    )
}
function RepReserve({ history, location, match }) {
    const session = JSON.parse(window.sessionStorage.result);
    const {u_id} = session;
    const query = queryString.parse(location.search);

    let si_id = query.si_id;
    let r_id = query.r_id;
    let date = query.date;
    const [modal, setModal] = useState(false);
    const toggle = (e) => {
        const { name } = e.target.dataset;
        setModal(!modal);
        
    }


    const [data, setData] = useState([]);

    let obj = {r_id:r_id}
    useEffect(() => {
        
        const fetchData = async () => {
            instance.post('/reserve/r_id',obj).then(function(res){

                setData(res.data[0]);  
            });
 
        };

        fetchData();

    }, []);

    console.log('data : ', data)
    let contract_num = '';
    if(data.contract_num){
        contract_num = data.contract_num;
    }


    const goHome = () => {
        history.push('/');
    }
    const wid5 = {
        width:'7%'
    }

   return (
        <div className="container">
            <div className="text-center">
                <div className="mt-5 mb-5">
                    <img style={wid5} src={check} className="mt-5 mb-5"/>
                </div>
                <div className="sinTextPC font-weight-bold mb-5">신청이 완료되었습니다.</div>
                <div className="sinTextPC2 text-lightgray">시공사 정보입력 이후로 작업내역을</div>
                <div className="sinTextPC2 text-lightgray">확인할 수 있습니다.</div>
            </div>
            <LoadSigong si_id={si_id}/> 

            <div className="mt-5 w-100 text-center mb-5">
                 {
                    contract_num
                    ?
                    <span className="btn btn-secondary col-3 mr-5  r_btnsize">프로모션 인증완료</span>
                    :
                    <span className="btn btn-primary col-3 mr-5 r_btnsize" onClick={toggle}>프로모션 인증(계약번호 인증)</span>

                    
                }
                <span className="btn_pad btn btn-secondary col-3 mr-5  d-inline-block btn-block " onClick={() => history.push('/myReserve')}>예약 내역</span>
                <span className="btn_pad btn btn-primary col-3 mr-5  d-inline-block " onClick={goHome}>확인</span>
            </div>
            <ModalPage r_id = {r_id} data={date} si_id={si_id} toggle={toggle} modal={modal} />
        </div>
        
   );
}

export default RepReserve;
